import { PlayslipMessageGroup } from '@Generated/back-office-client/src'
import { ThemeColorsFormData, ThemeColorRole } from './types'

/** The theme a host app gets when it names none. */
export const DEFAULT_THEME_ID = 'default'

/** The identifier rule the endpoint enforces; a value that fails it comes back as a 422. */
export const THEME_ID_PATTERN = /^[a-z0-9][a-z0-9-]{0,63}$/

export const THEME_ID_ERROR =
  'Use lowercase letters, numbers and hyphens, starting with a letter or number.'

export const THEME_ID_TAKEN_ERROR = 'A theme with that identifier already exists.'

export const HEX_COLOR_ERROR =
  'Enter a colour as #RRGGBB, or leave it blank to keep the built-in colour.'

export const SAVE_FAILED_MESSAGE = 'That could not be saved. Please try again.'

export const CREATE_FAILED_MESSAGE = 'That theme could not be created. Please try again.'

export const DELETE_FAILED_MESSAGE = 'That theme could not be deleted. Please try again.'

export const LOAD_FAILED_MESSAGE = 'Playslip themes could not be loaded. Please try again.'

export const THEME_LOAD_FAILED_MESSAGE = 'That theme could not be loaded. Please try again.'

export const THEME_SAVED_MESSAGE = 'Theme saved.'

export const COLOR_ROLES: { role: ThemeColorRole; label: string; description: string }[] = [
  {
    role: 'ctaColor',
    label: 'Call to action',
    description: 'Fill behind the committing action in the playslip builder.',
  },
  {
    role: 'ctaFontColor',
    label: 'Call to action text',
    description: 'Label colour on the committing action.',
  },
  {
    role: 'accentColor',
    label: 'Accent',
    description: 'Fill for a chosen control a game supplies no colour for.',
  },
  {
    role: 'accentBackgroundColor',
    label: 'Accent background',
    description: 'Tint a chosen option sits on.',
  },
  { role: 'fontColorPrimary', label: 'Primary text', description: 'Primary text colour.' },
  { role: 'fontColorSecondary', label: 'Secondary text', description: 'Secondary text colour.' },
  { role: 'borderColor', label: 'Borders', description: 'Borders and dividers.' },
]

/** Mirrors the SDK's built-in palette, so the preview shows what an unset role will draw. */
export const BUILT_IN_COLORS: ThemeColorsFormData = {
  ctaColor: '#FF9800',
  ctaFontColor: '#232323',
  accentColor: '#FF9800',
  accentBackgroundColor: '#FFF7EA',
  fontColorPrimary: '#232323',
  fontColorSecondary: '#6F6F6F',
  borderColor: '#D8D8D8',
}

export const EMPTY_COLORS_FORM: ThemeColorsFormData = {
  ctaColor: '',
  ctaFontColor: '',
  accentColor: '',
  accentBackgroundColor: '',
  fontColorPrimary: '',
  fontColorSecondary: '',
  borderColor: '',
}

/** What each catalog group is called in the editor, in the order the editor lists them. */
export const MESSAGE_GROUPS: { group: PlayslipMessageGroup; label: string }[] = [
  { group: PlayslipMessageGroup.actions, label: 'Buttons' },
  { group: PlayslipMessageGroup.headings, label: 'Headings' },
  { group: PlayslipMessageGroup.games, label: 'Game list' },
  { group: PlayslipMessageGroup.banner, label: 'Game banner' },
  { group: PlayslipMessageGroup.prompts, label: 'Prompts' },
  { group: PlayslipMessageGroup.optionRows, label: 'Builder options' },
  { group: PlayslipMessageGroup.prizes, label: 'Prizes' },
  { group: PlayslipMessageGroup.order, label: 'Order' },
  { group: PlayslipMessageGroup.confirmations, label: 'Confirmations' },
  { group: PlayslipMessageGroup.savedOrders, label: 'Saved orders' },
  { group: PlayslipMessageGroup.barcodes, label: 'Barcodes' },
  { group: PlayslipMessageGroup.errors, label: 'Errors' },
]

export const MESSAGES_LOAD_FAILED_MESSAGE =
  'The playslip copy could not be loaded. Saving keeps the copy this theme already has.'

/** Defaults longer than this get a multi-line field. */
export const LONG_MESSAGE_LENGTH = 60

export const placeholderError = (unknown: string[]): string =>
  `Only words in braces that the default uses can be filled in. Remove {${unknown.join('}, {')}}.`
